import { useEffect, useState } from "react";
import { _adr } from "../address";
import { CheckToken } from "./services";
import { Route, Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { isEmptyObject } from "./tools";
export const ProtectedRoute = ({ element: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  useEffect(() => {
    CheckToken()
      .then((validToken) => {
        // if (validToken && rest?.role) {
        if (validToken && _currentUser && !isEmptyObject(_currentUser)) {
          // if (rest?.role === "global" || _currentUser.roles.includes(rest?.role)) {
          setIsAuthenticated(validToken);
          // if (rest?.role === "global") {
          //   setIsAuthenticated(true);
          // } else {
          //   setIsAuthenticated(false);
          // }
        } else {
          setIsAuthenticated(false);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" style={{ margin: "auto" }} />
        </div>
      </>
    );
  }

  return isAuthenticated ? <Component /> : <Navigate to={_adr.Root + _adr.Landing.Index} replace state={{ from: rest.path }} />;
};

export const ProtectedRouteLogin = ({ element: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  useEffect(() => {
    CheckToken()
      .then((validToken) => {
        let returnState = false;
        if (validToken && !isEmptyObject(_currentUser) && rest.role === "global") {
          // setIsAuthenticated(true);
          returnState = false;
        } else if (validToken && !isEmptyObject(_currentUser)) {
          returnState = true;
          // setIsAuthenticated(true);
        } else {
          returnState = false;
          // setIsAuthenticated(false);
        }
        setIsAuthenticated(returnState);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" style={{ margin: "auto" }} />
        </div>
      </>
    );
  }

  return isAuthenticated ? <Navigate to={_adr.Root + _adr.Landing.Index} replace state={{ from: rest.path }} /> : <Component />;
};

export const CheckLoginUser = async () => {
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  return new Promise(async (resolve, reject) => {
    try {
      const isToken = await CheckToken();
      if (isToken && !isEmptyObject(_currentUser)) {
        resolve(true);
      } else {
        reject(false);
      }
    } catch (error) {
      reject(false);
    }
  });
};
